<button 
    class="primary-button"
    [style.background-color]="color"
    (click)="emitClick()" 
    [disabled]="disabled"
>
    {{buttonText}}
</button>
